import React, { useState } from "react";
import { Eye, EyeOff, Lock, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import toast from "react-hot-toast";

const AdminSigninPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      toast.error(err.cleanMessage || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="relative min-h-screen overflow-hidden bg-[#061A40] flex items-center justify-center px-5 py-10">
      <div className="absolute inset-0 bg-gradient-to-br from-[#061A40] via-[#003B73] to-[#F4B000]" />

      <div className="absolute -top-32 -left-32 w-80 h-80 bg-[#F4B000]/25 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-white/15 rounded-full blur-3xl" />

      <form
        onSubmit={submit}
        className="relative z-10 w-full max-w-md bg-white rounded-[28px] shadow-2xl p-7 md:p-8 border border-white/30"
      >
        <div className="mb-8 text-center">
          <img
            src="/assets/images/logo2.png"
            alt="OGFZA Logo"
            className="w-20 h-20 mx-auto object-contain mb-4"
          />

          <h1 className="text-2xl md:text-3xl font-black text-[#061A40]">
            Admin Login
          </h1>

          <p className="text-slate-500 text-sm mt-2 leading-6">
            Oil and Gas Free Zones Authority CMS
          </p>
        </div>

        <label className="block mb-4">
          <span className="text-sm font-bold text-slate-700">Email Address</span>

          <div className="mt-2 flex items-center gap-3 border border-slate-200 rounded-2xl px-4 py-3 focus-within:border-[#003B73] focus-within:ring-4 focus-within:ring-[#003B73]/10 transition">
            <Mail size={18} className="text-slate-400" />

            <input
              type="email"
              required
              autoComplete="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full outline-none text-sm text-slate-800 placeholder:text-slate-400"
              placeholder="Enter admin email"
            />
          </div>
        </label>

        <label className="block mb-6">
          <span className="text-sm font-bold text-slate-700">Password</span>

          <div className="mt-2 flex items-center gap-3 border border-slate-200 rounded-2xl px-4 py-3 focus-within:border-[#003B73] focus-within:ring-4 focus-within:ring-[#003B73]/10 transition">
            <Lock size={18} className="text-slate-400" />

            <input
              type={show ? "text" : "password"}
              required
              autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full outline-none text-sm text-slate-800 placeholder:text-slate-400"
              placeholder="Enter password"
            />

            <button
              type="button"
              onClick={() => setShow(!show)}
              className="text-slate-400 hover:text-[#003B73] transition"
              aria-label={show ? "Hide password" : "Show password"}
            >
              {show ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </label>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-4 rounded-2xl bg-[#061A40] hover:bg-[#003B73] text-white font-black transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>

        <p className="text-center text-xs text-slate-400 mt-6">
          Secure access for authorised OGFZA administrators only.
        </p>
      </form>
    </main>
  );
};

export default AdminSigninPage;